import { useRef } from 'react';

import { trackGA4SelectItem } from '@/common/analytics/gtm/item/trackSelectItem';
import { EventMessage } from '@/common/analytics/gtm/types';
import {
  trackGA4AddToWishlist,
  trackGA4RemoveFromWishlist,
} from '@/common/analytics/gtm/wishlist/trackWishlistAction';
import {
  SliderArtworkItem,
  SliderArtworkItemProps,
} from '@/common/components/SliderArtworkItem/SliderArtworkItem';
import { ComponentMetadata } from '@/common/components/types';
import { UseSlideImpression } from '@/common/impressions/useSliderImpression';

interface Props extends Omit<SliderArtworkItemProps, 'onClick'> {
  useSlideImpression: UseSlideImpression<EventMessage>;
  metadata: ComponentMetadata;
  index: number;
}

const SliderArtworkItemWithAnalytics = ({
  useSlideImpression,
  metadata,
  index,
  item,
  ...props
}: Props) => {
  const ref = useRef(null);
  const eventMessage = {
    message: { index, externalId: item.externalId, internalId: item.internalId },
    metadata,
  };

  const trackEvent = (trackingFunction: (eventMessage: EventMessage) => void) => () =>
    trackingFunction(eventMessage);

  useSlideImpression(ref, eventMessage);

  return (
    <SliderArtworkItem
      item={item}
      ref={ref}
      {...props}
      onAddToWishlist={() => {
        trackEvent(trackGA4AddToWishlist)();
        trackEvent(trackGA4SelectItem)();
      }}
      onClick={trackEvent(trackGA4SelectItem)}
      onRemoveFromWishlist={() => {
        trackEvent(trackGA4RemoveFromWishlist)();
        trackEvent(trackGA4SelectItem)();
      }}
    />
  );
};

export default SliderArtworkItemWithAnalytics;
